// 為了 千分位
export const formatNumberWithCommas = (str: string) => {
    return str ? str.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''
}